export default "__VITE_ASSET__ec1d5259__"